import { MONTH, QUARTER, WEEK, YEAR } from './relativeDates';

export const GROSS_SALES = 'GROSS_SALES';
export const SALES_QUANTITY = 'SALES_QUANTITY';
export const TIPS = 'TIPS';

export const PeriodType = {
  CURRENT: 'current',
  LAST: 'last',
  STLY: 'stly',
};

export const METRIC_OPTIONS = [
  {
    value: GROSS_SALES,
    label: 'Gross Sales',
  },
  {
    value: SALES_QUANTITY,
    label: 'Sales Qty',
  },
  // {
  //   value: TIPS,
  //   label: 'Tips',
  // },
];

export const METRIC_TO_GRAPH_TYPE = {
  [GROSS_SALES]: 'revenue',
  [SALES_QUANTITY]: 'demand',
  // [TIPS]: 'tips',
};

export const PERIOD_OPTIONS = [
  {
    value: WEEK,
    label: 'Week',
  },
  {
    value: MONTH,
    label: 'Month',
  },
  {
    value: QUARTER,
    label: 'Quarter',
  },
  {
    value: YEAR,
    label: 'Year',
  },
];

export const PERIOD_TO_FORMAT_TYPE = {
  [WEEK]: 'weekday',
  [MONTH]: 'full',
  [QUARTER]: 'month-year',
  [YEAR]: 'month-year',
};

export const GRAPH_TIME_GRANULARITY_LABELS = {
  [WEEK]: 'Day',
  [MONTH]: 'Day',
  [QUARTER]: 'Month',
  [YEAR]: 'Month',
};

export const MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const WEEKDAY_NAMES = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export const PERFORMANCE_SETTINGS_KEYS = {
  PERIOD: 'period',
  METRIC: 'metric',
  CUMULATIVE: 'cumulative',
  BREAKDOWN_BY_DIMENSION_ID: 'breakdown_by_dimension_id',
  BREAKDOWN_PERIOD: 'breakdown_period',
};

export const DEFAULT_PERFORMANCE_SETTINGS = {
  [PERFORMANCE_SETTINGS_KEYS.PERIOD]: MONTH,
  [PERFORMANCE_SETTINGS_KEYS.METRIC]: GROSS_SALES,
  [PERFORMANCE_SETTINGS_KEYS.CUMULATIVE]: true,
  [PERFORMANCE_SETTINGS_KEYS.BREAKDOWN_BY_DIMENSION_ID]: 0,
  [PERFORMANCE_SETTINGS_KEYS.BREAKDOWN_PERIOD]: PeriodType.CURRENT,
};
